const defaultLocale = 'en-US';

const nextI18nLocales = [defaultLocale, 'en-GB', 'en-AU', 'en-CA', 'de-DE', 'de-AT'];

module.exports = {
  nextI18nLocales,
  defaultLocale,
};
